import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/root-store-context";
import ShortLayout from "../../components/layout/ShortLayout";
import KanbanTasks from "../KanbanTasks/KanbanTasks";
import ProjectTabs from "../Projects/ProjectTabs";
import ProjectPage from "../Projects/ProjectPage"; 

const AnonymousPage = observer(() => {
  const location = useLocation();
  const { anonymousStore, apiStore } = useStore();
  const [isInvalidToken, setIsInvalidToken] = useState(false);
  const [activeTab, setActiveTab] = useState<'info' | 'tasks'>('info');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setIsInvalidToken(true);
      return;
    }

    apiStore.setConfigApi({
      token,
      companyId: "0",
      userId: 0,
    });

    anonymousStore.getTaskStatuses().catch(console.log);
    anonymousStore.getTasks().catch(console.log);    

    if (location.pathname.includes("/tasks")) {
      setActiveTab("tasks");
    } else {
      setActiveTab("info");
    }
  }, [location.search, location.pathname]);

  if (isInvalidToken) {
    return <Navigate to="/404" replace />;
  }

  return (
    <ShortLayout headerStyle={1} footerStyle={2}>
      <div style={{ padding: 20 }}>
        <ProjectTabs
          isAnonymous={true}
          onTabChange={(key) => setActiveTab(key as 'info' | 'tasks')}
        />

        {activeTab === 'tasks' ? (
          <KanbanTasks
            isShowInternalLoader={true}
            // statuses={anonymousStore.projectStatuses}
            // tasks={anonymousStore.kanbanTask}
            isAnonymous={true}
            getTaskByIdProp={anonymousStore.getTaskById}
            getTaskCommentsProp={anonymousStore.getTaskComments}
            getTaskChangesProp={anonymousStore.getTaskChanges}
            createCommentProp={anonymousStore.createComment}
            getTaskAttachmentsProp={anonymousStore.getAttachments}
            uploadTaskAttachmentProp={anonymousStore.uploadTaskAttachment}
            updateTaskScheduledAndPriorityProp={anonymousStore.updateTaskScheduledAndPriority}
            getTaskTimeMetricsProp={anonymousStore.getTaskTimeMetrics}
          />
        ) : (
          <ProjectPage
            isShowInternalLoader={false}
            isAnonymous={true}
            getDocumentationByProjectProp={anonymousStore.getDocumentationByProject}
          />
        )}
      </div>
    </ShortLayout>
  );
});

export default AnonymousPage;
